var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isAffiliate)?_c('button',{staticClass:"button choice-button",class:{'choice-button--disabled': _vm.retry>0},on:{"click":function($event){return _vm.resendSms()}}},[_c('span',[_vm._v("Renvoyer un nouveau code")]),_vm._v(" "),_c('img',{attrs:{"src":"/images/new_branding/retry.svg"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }